<template>
  <v-container pa-0>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card outlined class="flush-to-bottom">
          <v-card-title class="subtitle-1">
            Total actions completed
          </v-card-title>
          <v-card-text class="headline red--text">
            {{ totalCompletedActions }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card outlined class="flush-to-bottom">
          <v-card-title class="subtitle-1">
            Users who have completed actions
          </v-card-title>
          <v-card-text class="headline red--text">
            {{ uniqueUserCompletions }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card outlined class="flush-to-bottom">
          <v-card-title class="subtitle-1">
            Unique actions that have been completed
          </v-card-title>
          <v-card-text class="headline red--text">
            {{ uniqueActionCompletions }}
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card outlined class="flush-to-bottom">
          <v-card-title class="subtitle-1">
            Most completed actions by state
          </v-card-title>
          <v-card-text class="headline red--text">
            {{ stateWithMostCompletions }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-container pa-0>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                State
              </th>
              <th class="text-left">
                Completions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in completionsByState"
              :key="item.state"
              class="w-50"
            >
              <td class="w-50">
                {{ item.state }}
              </td>
              <td class="w-50">
                {{ item.completions }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </v-container>
</template>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
td {
  max-width: 50px !important;
}
</style>

<script>
import { mapState } from 'vuex';
import { EventBus, capitalize, fiftyStates } from 'utils';

export default {
  name: 'ActionAnalytics',

  data: function() {
    return {
      stateNames: fiftyStates.map(state => state.name),
    };
  },

  computed: {
    ...mapState(['completedActions']),

    totalCompletedActions() {
      return this.completedActions.length;
    },

    uniqueUserCompletions() {
      const userIds = this.completedActions.map(a => a.userId);
      return [...new Set(userIds)].length;
    },

    uniqueActionCompletions() {
      const actionIds = this.completedActions.map(a => a.actionId);
      return [...new Set(actionIds)].length;
    },

    completionsByState() {
      if (this.completedActions.length) {
        const groupedByState = this.completedActions.reduce((acc, current) => {
          acc[current.states] = acc[current.states] ? acc[current.states] + 1 : 1;
          return acc;
        }, {});

        return Object.keys(groupedByState)
          .map(key => ({ state: capitalize(key), completions: groupedByState[key] }))
          .filter(o => o.state !== 'National')
          .sort((a, b) => b.completions - a.completions);
      }

      return [];
    },

    stateWithMostCompletions() {
      return this.completionsByState.length ? this.completionsByState[0].state : 'N/A';
    },
  },

  created() {
    this.getCompletedActions();
  },

  methods: {
    async getCompletedActions() {
      if (this.completedActions.length) {
        return;
      }

      try {
        await this.$store.dispatch('setCompletedActions');
      } catch (e) {
        EventBus.$emit('alert-error', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle-1 {
  line-height: 1.3;
}
</style>
